import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=19c5ffde&scoped=true"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&id=19c5ffde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5ffde",
  null
  
)

export default component.exports